import { Link } from "react-router-dom"
import styles from "./index.module.less"
import { useLocation } from "react-router-dom"
import { useSelector } from "react-redux"

function Menus() {
  const currentPath = useLocation().pathname
  const easyLiao = () => {
    window.openJesongChatByGroup(121, 52601)
    return false
  }

  const regionId = useSelector((state) => {
    return state.region.checked._id
  })

  console.log("menus.regionId=", regionId)
  function MenuItem(props) {
    return (
      <li className={currentPath === props.to ? styles.current : ""}>
        {props.to && (
          <Link
            to={`${props.to}${
              regionId && regionId !== "0" ? "?regionId=" + regionId : ""
            }`}
          >
            <h5>{props.name}</h5>
            <span>{props.en}</span>
          </Link>
        )}
        {!props.to && (
          <a onClick={easyLiao}>
            <h5>{props.name}</h5>
            <span>{props.en}</span>
          </a>
        )}
      </li>
    )
  }
  return (
    <ul className={styles["nav-menus"]}>
      <MenuItem to="/" name="首页" en="Home" />
      <MenuItem to="/fudu" name="高考复读" en="Repetition Class" />
      <MenuItem to="/yikao" name="艺考中心" en="Art Examination" />
      <MenuItem to="/jixun" name="短期集训" en="Short-term Training" />
      <MenuItem to="/jiaoxue" name="教学管理" en="Teaching Management" />
      <MenuItem name="教学教研" en="Teaching And Researc" />
      <MenuItem name="校区查询" en="Campus Inquiry" />
      <MenuItem name="招生简章" en="Recruit Students" />
    </ul>
  )
}

export default Menus
